import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent'
import prop from 'ramda/src/prop'
import { camelCaseSpace, capitalize } from 'root/src/shared/util/stringCase'
import {
	readablePlatformsMap,
	readableKeyTypesMap,
	dropKeyPlatformRegionsOptionsMap,
} from 'root/src/shared/constants/dropKeys'

const typePartMap = {
	[brandProductTypesEnum.customProduct]: 'for viewers',
	[brandProductTypesEnum.dropKey]: 'for viewers',
	[brandProductTypesEnum.dropCode]: 'for viewers',
	[brandProductTypesEnum.placeholder]: '',
}

export const getFullKeyName = (
	{ game, keyType, region, platform },
) => `${prop('name', game)} ${readablePlatformsMap[platform]} ${camelCaseSpace(region)} ${readableKeyTypesMap[keyType]} Key`

export default (
	{ amount, name, type, region, platform }, forViewers = false,
) => {
	let finalName = ''

	if (amount) {
		finalName += `(${amount}) `
	}
	finalName += `${name} `
	if (region) {
		finalName += `${getRegionLabelByPlatform({ region, platform })} `
	}
	if (forViewers) {
		finalName += typePartMap[type]
	}

	return finalName.trim()
}

const getRegionLabelByPlatform = ({ region, platform }) => {
	const option = dropKeyPlatformRegionsOptionsMap[platform]
	const regionOption = option?.find(({ value }) => value === region)

	if (!regionOption) {
		return capitalize(region)
	}

	return regionOption.label
}
